import dayjs, { Dayjs } from 'dayjs';
import { MEETING_TYPES, MeetingType } from 'commons/types/meetingsTypes';

interface DoctorCardProps {
  rdvType: MeetingType;
  doctorName: string | undefined;
  avatar: string | undefined;
  startDate: Dayjs;
}

export default function DoctorCard({
  rdvType,
  doctorName,
  avatar,
  startDate,
}: DoctorCardProps) {
  let card;
  const name =
    doctorName === undefined || doctorName === '' ? undefined : doctorName;
  switch (rdvType) {
    case MEETING_TYPES.RDV_1:
      card = <Advisor name={name} />;
      break;
    case MEETING_TYPES.RDV_2:
      card = <Nurse name={name} />;
      break;
    case MEETING_TYPES.RDV_SWITCH:
      card = (
        <Advisor
          name='Corentin - Infirmier'
          imgSRC='/infirmier_referent.png'
        />
      );
      break;
    default:
      card = (
        <Doctor
          name={name}
          avatar={avatar}
        />
      );
      break;
  }

  return (
    <div className='flex flex-col items-center text-base text-center'>
      <p className='pt-4 m-0 font-semibold capitalize'>
        {dayjs(startDate, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('dddd LL')}
      </p>
      <p className='w-20 h-8 mt-1 font-semibold leading-8 text-center text-white capitalize bg-secondary rounded-2xl'>
        {dayjs(startDate, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('HH:mm')}
      </p>
      <p className='text-xs'>avec</p>
      {card}
    </div>
  );
}

interface AdvisorProps {
  name: string | undefined;
  imgSRC?: string;
}

function Advisor({ name, imgSRC = '/conseiller.jpg' }: AdvisorProps) {
  return (
    <div className='flex w-64 mb-6'>
      <img
        className='object-cover w-16 h-16 rounded-xl'
        src={imgSRC}
        alt='Conseiller'
      />
      <div className='flex flex-col justify-start mt-3 ml-2 text-left'>
        <p className='m-0 font-semibold'>{name || 'Un téléconseiller'}</p>
        <p className='text-sm'>conseiller médical</p>
      </div>
    </div>
  );
}
interface NurseProps {
  name: string | undefined;
}
function Nurse({ name }: NurseProps) {
  return (
    <div className='flex w-64 mb-6'>
      <img
        className='object-cover w-16 h-16 rounded-xl'
        src='/nurse.jpg'
        alt='Infirmier'
      />
      <div className='flex flex-col justify-start mt-3 ml-2 text-left'>
        <p className='m-0 font-semibold'>{name || 'Un infirmier'}</p>
        <p className='text-sm'>infirmière spécialisée</p>
      </div>
    </div>
  );
}

interface DoctorProps {
  name: string | undefined;
  avatar: string | undefined;
}
function Doctor({ name, avatar }: DoctorProps) {
  return (
    <div className='flex w-64 mb-6'>
      <img
        className='object-cover w-16 h-16 rounded-xl'
        src={avatar || '/doctor.jpg'}
        alt={`${name}`}
      />
      <div className='flex flex-col justify-start mt-3 ml-2 text-left'>
        <p className='m-0 font-semibold'>
          {name ? `Dr ${name}` : 'Un docteur'}
        </p>
        <p className='text-sm'>médecin du sommeil</p>
      </div>
    </div>
  );
}
